import { api } from './_apiInterface';
import { pointer } from 'src/app-config';
import { typePublicMinistryDoc, typePublicMinistryMonthlyService } from '@monorepo/models';

class PublicMinistryServices {
    private _base = pointer.publicMinistry;
    //
    AddTerritoryToHTHService = async (serviceId: number, territoryNumber: number, month: number, year: number) => {
        const data = await api.SendRequest(this._base, 'PATCH', { month, serviceId, territoryNumber, year });
        return data;
    }
    Delete = async (monthlyService: typePublicMinistryMonthlyService) => {
        const data = await api.SendRequest(this._base, 'DELETE', { monthlyService });
        return data;
    }
    Get = async () => {
        const data = await api.SendRequest<{ publicMinistryDoc: typePublicMinistryDoc; }>(this._base, 'GET');
        return data;
    }
    Save = async (monthlyService: typePublicMinistryMonthlyService) => {
        const data = await api.SendRequest(this._base, 'POST', { monthlyService });
        return data;
    }
}

export const publicMinistryServices = new PublicMinistryServices();
